import helpersShowSlice from '@/app/common/reducers/helpersShowSlice';
import joyTourShowSlice from '@/app/common/reducers/joyTourShowSlice';
import recentVisitSlice from '@/app/common/reducers/recentVisitSlice';
import serpDataSlice from '@/app/Serp/reducers/serpDataSlice';
import backlinkfiltersSlice from '@/app/BacklinkNew/reducers/backlinkfiltersSlice';
import gridDrawerSlice from '@/app/common/reducers/gridDrawerSlice';
import filterSlice from '@/app/common/reducers/filterSlice';
import userSlice from '@/app/common/reducers/userSlice';
import domainSlice from '@/app/common/reducers/domainSlice';
import cannibalizationsModal from '@/app/KeywordTracker/reducers/cannibalizationsModal';
import conflictModal from '@/app/KeywordTracker/reducers/conflictModal';
import selectedKeys from '@/app/KeywordTracker/reducers/selectedKeys';
import gapReportModal from '@/app/KeywordResearch/reducers/gapReportModal';
import drawer from '@/app/common/reducers/drawer';
import notifShowSlice from '@/app/common/reducers/notifShowSlice';
import simpleModal from '@/app/common/reducers/simpleModal';

const reducers = [
  // DRAWER
  drawer,
  simpleModal,
  gridDrawerSlice, // STACK DRAWER!
  // MODAL
  gapReportModal,
  conflictModal,
  cannibalizationsModal,

  //
  helpersShowSlice,
  notifShowSlice,
  joyTourShowSlice,
  recentVisitSlice,
  serpDataSlice,
  backlinkfiltersSlice,
  filterSlice,
  userSlice,
  domainSlice,
  selectedKeys
];
export default reducers;
